import React from 'react';
import { NewsDetailStyles as S } from './NewsDetail.styles';
import { Grid } from '@helpers/grid';
import NewsDetailLines from '@img/news-detail.png';
import withWidget from '@hoc/withWidget';
import { HydrateOption } from '@core/enums';
import { withMotion } from '@hoc/withMotion';
import { AnimatePresence } from 'framer-motion';
import { PuffLoader } from 'react-spinners';
import { imageUrl, extractPublicId } from '@helpers/cloudinary';
import useMedia from '@hooks/useMedia';
import { Device, until } from '@helpers/media';
const BlockquoteSVG = `<svg viewBox="0 0 84 55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.375 0C10.0286 0 0.75 9.27857 0.75 20.625V55H35.125V20.625H7.625C7.625 12.998 13.748 6.875 21.375 6.875V0ZM69.5 0C58.1536 0 48.875 9.27857 48.875 20.625V55H83.25V20.625H55.75C55.75 12.998 61.873 6.875 69.5 6.875V0ZM7.625 27.5H28.25V48.125H7.625V27.5ZM55.75 27.5H76.375V48.125H55.75V27.5Z" fill="#669900" /></svg>`;
const NewsDetail = (props) => {
    const [imageLoaded, setImageLoaded] = React.useState(false);
    const imageRef = React.useRef(null);
    const isMobile = useMedia([until(Device.Desktop)], [true], false);
    React.useEffect(() => {
        if (imageRef.current?.complete) {
            setImageLoaded(true);
        }
    }, [imageRef]);
    return (React.createElement(S.Wrapper, null,
        React.createElement(Grid.Default, null,
            React.createElement(S.Container, null,
                React.createElement(S.TopSection, null,
                    React.createElement(S.TopSectionLeftContent, null,
                        React.createElement(S.TopSectionDate, null, props.date),
                        React.createElement(S.TopSectionTitle, null, props.title),
                        props.intro && (React.createElement(S.TopSectionIntro, { dangerouslySetInnerHTML: { __html: props.intro } }))),
                    React.createElement(S.TopSectionImage, { as: props.videoCta ? 'a' : 'div', href: props.videoCta?.url, target: "_blank", "aria-label": props.videoCta?.title, "data-full-image": props.fullImage },
                        React.createElement(AnimatePresence, null, !imageLoaded && (React.createElement(S.SpinnerWrapper, null,
                            React.createElement(PuffLoader, null)))),
                        React.createElement(S.TopSectionLazyImageWrapper, { "data-loaded": imageLoaded },
                            React.createElement("img", { ref: imageRef, loading: "eager", src: props.fullImage
                                    ? imageUrl(extractPublicId(props.image), isMobile ? 'c_lpad,g_east' : 'c_lpad,g_east,w_1100')
                                    : props.image, onLoad: () => setImageLoaded(true) })),
                        React.createElement("img", { loading: "lazy", src: NewsDetailLines }))),
                props.richText && (React.createElement(S.RichTextArea, null,
                    React.createElement("div", { dangerouslySetInnerHTML: {
                            __html: props.richText
                                .replaceAll('<blockquote>', `<blockquote><div>${BlockquoteSVG}</div><div>`)
                                .replaceAll('</blockquote>', '</div></blockquote>'),
                        } })))))));
};
export default withWidget(withMotion(NewsDetail), 'NewsDetail', { hydrate: HydrateOption.InView });
